import { axios } from "../axios.instance";

export type RequestUpdateCardRequest = object;

export type RequestUpdateCardResponse = {
  requestId: string;
};

export const requestUpdateCard = async (body: RequestUpdateCardRequest): Promise<RequestUpdateCardResponse> => {
  const { data } = await axios.post(`/payments/request-update-card`, body);

  return data;
};
